import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
// import { BrowserQRCodeReader } from '@zxing/library';
// import { Camera, CameraOptions } from '@ionic-native/camera';

import { LoginPage } from '../login/login';
import { StakingconfirmPage } from '../stakingconfirm/stakingconfirm';
import { StakingcompletePage } from '../stakingcomplete/stakingcomplete';

// import * as $ from "jquery";

/**
 * Generated class for the StakingPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-staking',
  templateUrl: 'staking.html',
})
export class StakingPage {

    loginId: string;
	api_key: string;
	version: string;
	email: string;

	balance: string;
	month: string;
	day: string;
	min: string;
	rate: string;
	value: string = '';
    coin_unit: string;
    unit: string;
    
    texts: any = [];
	language : string;
	imagePath:string;

    isSend : boolean = true;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
		public app: App
    ) {
	
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "staking");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.email = localStorage.getItem("email");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.unit = localStorage.getItem("unit");

        this._get_texts();

        this._init();
        
    }

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).staking;
	}

    keyDown() {
        if (this.value == undefined || this.value == null) {
			var tmps: string = "";
		} else {
			tmps = this.value;
		}
		
        this.value = tmps.replace(/[^0-9]/g, "");
        
    }

    keyUp() {
        if(this.value != null || this.value != "") {
            let tmps: string = this.value;
            tmps = tmps.replace(/[^0-9]/g, "");
            this.value = tmps.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
	}
	
	_init() {
        this.value = '';
        
        //// 서버로부터의 데이타
        let url = "staking/base";
        let body = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version
        });
        this.http.post(url, body).then((res: any) => {
            if(res.result=="OK"){
                this.balance = res.balance;
                this.month = res.month;
                this.day = res.day;
                this.min = res.min;
                this.rate = res.rate;

            } else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.navCtrl.pop();

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                this.navCtrl.pop();
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
            
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
	}

	_apply(){
        this.isSend = false;

		if (!this.value || this.value.length == 0) {
            const toast = this.toastCtrl.create({
                message: this.texts.toastM_amount,
                duration: 2000,
                position: 'middle'
            });
            toast.present();
            this.isSend = true;
            return ;
        }

        // this.navCtrl.push(StakingconfirmPage, {value: this.value});

        let modal = this.modalCtrl.create(StakingconfirmPage, {value: this.value});
        modal.present();

        modal.onDidDismiss( data => {
            if (data == 'ok') {
                this.isSend = true;
                this.navCtrl.pop();
            } else {
                this.isSend = true;
                this._init();
            }

        });

        // modal.onDidDismiss( data => {
        //     if (data != '') {
        //         this.isSend = true;

        //         let url = "staking/base/index/save";
        //         let body = JSON.stringify({ 
        //             api: this.api_key,
        //             language: this.language,
        //             version: this.version,
        //             date: data.date,
        //             start: data.start,
        //             end: data.end,
        //             value: data.value,
        //             idx: data.idx,
        //         });
        //         this.http.post(url, body).then((res: any) => {
        //             if(res.result=="OK"){
        //                 this.navCtrl.pop();
        //                 let modal = this.modalCtrl.create(StakingcompletePage);
        //                 modal.present();

        //             } else if(res.result ==="DONOT"){
        //                 let alert = this.alertCtrl.create({
        //                     message: res.message,
        //                     buttons: ['OK']
        //                 });
        //                 alert.present();
        //                 this.navCtrl.pop();

        //             } else if(res.result ==="LOGOUT"){
        //                 let alert = this.alertCtrl.create({
        //                     message: res.message,
        //                     buttons: ['OK']
        //                 });
        //                 alert.present();
        //                 localStorage.removeItem("loginId");
        //                 localStorage.removeItem("api_key");
        //                 this.app.getRootNav().setRoot(LoginPage);
                    
        //             } else {
        //                 this.navCtrl.pop();
        //                 let alert = this.alertCtrl.create({
        //                     message: res.message,
        //                     buttons: ['OK']
        //                 });
        //                 alert.present();
        //             }
                    
        //         },(err)=>{	
        //             //// HTTP 에러인 경우
        //             let alert = this.alertCtrl.create({
        //                 message: err,
        //                 buttons: ['OK']
        //             });
        //             alert.present();
                
        //         });
                

        //     } else {
        //         this.isSend = true;
        //         this._init();
        //     }
        // });
	}

    _cancel() {
        this.navCtrl.pop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/staking/staking.ts